export default __webpack_public_path__ + "youtube.1c27ddd00ad9804562c53426ac00d9bc.svg";